<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h480_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="借款/还款人"
                    prop="userName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.userName"
                      disabled
                    >
                      <el-button
                        v-if="eventType!=='view'"
                        slot="append"
                        icon="el-icon-search"
                        @click="selectUserFun()"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="类型"
                    :required="eventType!=='view'"
                  >
                    <el-radio-group
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.type"
                    >
                      <el-radio
                        :label="1"
                      >
                        借款
                      </el-radio>
                      <el-radio
                        :label="2"
                      >
                        还款
                      </el-radio>
                    </el-radio-group>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.typeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="借款/还款日期"
                    prop="happenDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.happenDate"
                      type="date"
                      class="data-picker"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :editable="false"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="金额"
                    prop="amount"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.amount"
                      style="width: 100%"
                      :disabled="eventType==='view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'amount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'amount',2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="用途说明"
                    prop="purpose"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.purpose"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 用户列表 -->
    <employee-list-dialog
      :dialog-visible.sync="dialogUserVisible"
      dialog-title="人员信息"
      @selectedLoanUserFun="selectedLoanUserFun"
    />
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 选择人员
import employeeListDialog from './employeeListDialog'
// 数据请求
import { initExpenseLoanListApi, saveOrUpdateExpenseLoanListApi } from '@/api/expenseLoanList'
export default {
  components: {
    employeeListDialog
  },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },      
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    userId: {
      type: Number,
      default: null
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        userName: [{ required: true, message: '请选择借款/还款人', trigger: 'blur' }],
        happenDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
        purpose: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      dialogUserVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          userName: '',
          userId: '',
          type: 1,
          typeStr: '',
          happenDate: '',
          amount: 0,
          purpose: '',
          remark: ''
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          if(this.userName !== ''){
            this.dialogAddEditViewForm.userName = this.userName
            this.dialogAddEditViewForm.userId = this.userId
          }
          this.loading = false
        }
      }
    },
  },
  methods: {
    // 加载数据
    initPageData () {
      initExpenseLoanListApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          if(key !== 'happenDate'){
            this.dialogAddEditViewForm[key] = data[key]
          }
        }
        this.dialogAddEditViewForm.happenDate = data.happenDateStr
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    selectUserFun(){
      this.dialogUserVisible = !this.dialogUserVisible
    },
    selectedLoanUserFun(val){
      this.dialogAddEditViewForm.userName = val.name
      this.dialogAddEditViewForm.userId = val.id
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      if(Number(this.dialogAddEditViewForm.amount) === 0){
        this.$message({
          message: '金额不能为0',
          type: 'warning'
        })
        return false
      }
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + (this.dialogAddEditViewForm.type === 1 ? '借款' : '还款'), '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateExpenseLoanListApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
